import { render, staticRenderFns } from "./audio-element.vue?vue&type=template&id=66dd7f96&scoped=true&"
import script from "./audio-element.vue?vue&type=script&lang=js&"
export * from "./audio-element.vue?vue&type=script&lang=js&"
import style0 from "./audio-element.vue?vue&type=style&index=0&id=66dd7f96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dd7f96",
  null
  
)

export default component.exports